const routes = [
    {
        path: "/esl/course",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "eslcourse_index"
        }
    }
]

export default routes;

